import ContextMissingError from "@errors/ContextMissingError";
import { createContext, useContext } from "react";

export default function context<T extends any>(): [React.Context<T | null>, () => T] {
    const context = createContext<T | null>(null)

    const use = () =>{
        const data = useContext(context)
        if (!data) throw new ContextMissingError()
        return data
    }
    
    return [context, use]
}